import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  BodyOne,
  HeadingTwo,
  DangerButton,
  SecondaryButton,
} from '@leagueplatform/genesis-commons';
import {
  Modal,
  ModalButtons,
  ModalContent,
} from 'apps/employer-experience/ui-kit';

class RemoveBenefitClassConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.onRemoveBenefitClass = this.onRemoveBenefitClass.bind(this);
    this.close = this.close.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated -- FIXME: automatically added for existing issue
  componentWillReceiveProps({ open }) {
    // eslint-disable-next-line react/destructuring-assignment -- FIXME: automatically added for existing issue
    if (this.state.open !== open) {
      this.setState({ open });
    }
  }

  onRemoveBenefitClass() {
    // eslint-disable-next-line react/destructuring-assignment -- FIXME: automatically added for existing issue
    this.props.removeBenefitClass();
  }

  close() {
    this.setState({ open: false });
    // eslint-disable-next-line react/destructuring-assignment -- FIXME: automatically added for existing issue
    this.props.close();
  }

  render() {
    const { open } = this.state;
    const { benefitClassName, isLastBenefitClass } = this.props;

    return (
      <div>
        <Modal open={open} onClose={this.close}>
          <HeadingTwo>
            <FormattedMessage
              id="REMOVE_BENEFIT_CLASS_CONFIRMATION_HEADER"
              values={{ benefitClassName }}
            />
          </HeadingTwo>
          <ModalContent>
            {!isLastBenefitClass() ? (
              <BodyOne>
                <FormattedMessage
                  id="REMOVE_BENEFIT_CLASS_CONFIRMATION_COPY"
                  values={{ benefitClassName }}
                />
              </BodyOne>
            ) : (
              <BodyOne>
                <FormattedMessage
                  id="REMOVE_LAST_BENEFIT_CLASS_ERROR_COPY"
                  values={{ benefitClassName }}
                />
              </BodyOne>
            )}
          </ModalContent>
          <ModalButtons>
            <SecondaryButton onClick={this.close}>
              <FormattedMessage id="REMOVE_BENEFIT_CLASS_CONFIRMATION_CANCEL_BTN" />
            </SecondaryButton>
            {!isLastBenefitClass() ? (
              <DangerButton
                positive
                onClick={this.onRemoveBenefitClass}
                marginLeft="one"
              >
                <FormattedMessage id="REMOVE_BENEFIT_CLASS_CONFIRMATION_REMOVE_BTN" />
              </DangerButton>
            ) : null}
          </ModalButtons>
        </Modal>
      </div>
    );
  }
}

RemoveBenefitClassConfirmation.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  benefitClassName: PropTypes.string.isRequired,
  removeBenefitClass: PropTypes.func.isRequired,
  isLastBenefitClass: PropTypes.func.isRequired,
};

export default injectIntl(RemoveBenefitClassConfirmation);
